// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-log-empty-state',
  templateUrl: './cts-gantry-log-empty-state.component.html',
  styleUrl: './cts-gantry-log-empty-state.component.scss',
})
export class CtsGantryLogEmptyStateComponent {
  @Input() onlyErrorsMsg: boolean = false;
}
